import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { FavoritesService, LiteralsService } from '../../services'
import {
  addFavoriteSuccessfulAction,
  fetchFavoritesAction,
  fetchFavoritesSuccessfulAction,
  fetchMoreFavoritesSuccessfulAction,
  fetchPastReservationsAction,
  fetchReservationsAction,
  isAddingFavoriteAction,
  isFetchingFavoritesAction,
  isFetchingMoreFavoritesAction,
  isRemovingFavoriteAction,
  removeFavoriteSuccessfulAction,
  setNotificationAction
} from '../actions'
import { IStoreState } from '../states'
import { FavoriteTypeKeys } from '../types'
import { HttpStatusCode } from 'axios'

// Worker Saga
function* fetchFavoritesAsync(action: any) {
  let favorites = []
  yield put(isFetchingFavoritesAction())
  try {
    favorites = yield call(FavoritesService.getFavorites, action.payload.size, action.payload.page)
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  }
  yield put(fetchFavoritesSuccessfulAction(favorites))
}

function* fetchMoreFavoritesAsync(action: any) {
  let favorites = []
  yield put(isFetchingMoreFavoritesAction())
  try {
    favorites = yield call(FavoritesService.getFavorites, action.payload.size, action.payload.page)
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  }
  yield put(fetchMoreFavoritesSuccessfulAction(favorites))
}

function* addFavoriteAsync(action: any) {
  try {
    const size = yield select((state: IStoreState) => state.reservations.size)
    yield put(isAddingFavoriteAction())
    yield call(FavoritesService.addFavorite, action.payload)
    yield put(
      setNotificationAction({
        isError: false,
        label: LiteralsService.get('saved', true)
      })
    )
    yield put(fetchReservationsAction(size, 1))
    yield put(fetchPastReservationsAction(size, 1))
    yield put(fetchFavoritesAction(size, 1))
  } catch (error: any) {
    let errorMessage = 'serverError'
    switch(error.status) {
      case HttpStatusCode.Conflict:
        errorMessage = 'duplicatedFavorite'
        break
    }
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get(
          errorMessage,
          true
        )
      })
    )
  } finally {
    yield put(addFavoriteSuccessfulAction())
  }
}

function* removeFavoriteAsync() {
  try {
    const size = yield select((state: IStoreState) => state.reservations.size)
    yield put(isRemovingFavoriteAction())
    const { id } = yield select(
      (state: IStoreState) => state.favorites.selectedFavorite
    )
    yield call(FavoritesService.removeFavorite, id)
    yield put(
      setNotificationAction({
        isError: false,
        label: LiteralsService.get('saved', true)
      })
    )
    yield put(fetchReservationsAction(size, 1))
    yield put(fetchPastReservationsAction(size, 1))
    yield put(fetchFavoritesAction(size, 1))
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  } finally {
    yield put(removeFavoriteSuccessfulAction())
  }
}

// Watcher Saga:
function* watchFetchFavoritesAsync() {
  yield takeLatest(FavoriteTypeKeys.FETCH_FAVORITES, fetchFavoritesAsync)
}

function* watchFetchMoreFavoritesAsync() {
  yield takeLatest(FavoriteTypeKeys.FETCH_MORE_FAVORITES, fetchMoreFavoritesAsync)
}

function* watchAddFavoriteAsync() {
  yield takeLatest(FavoriteTypeKeys.ADD_FAVORITE, addFavoriteAsync)
}

function* watchRemoveFavoriteAsync() {
  yield takeLatest(FavoriteTypeKeys.REMOVE_FAVORITE, removeFavoriteAsync)
}

// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    watchFetchFavoritesAsync(),
    watchFetchMoreFavoritesAsync(),
    watchAddFavoriteAsync(),
    watchRemoveFavoriteAsync()
  ])
}
